import type { DefaultTheme } from 'styled-components';
import { dark } from './dark';
import { light } from './light';

export const themes: Record<'dark' | 'light', DefaultTheme> = { dark, light };
